import store from '@/store'
import { Toast } from 'vant'
/**
 * 计算字符串在文档中的长度
 */
export const conputeTextWidth = text => {
  let span = document.createElement('span')
  span.innerHTML = text
  span.style.visibility = 'hidden'
  span.style.fontSize = '14px'
  document.body.appendChild(span)
  let width = span.offsetWidth
  document.body.removeChild(span)
  return width
}

/**
 * 文件流下载处理
 */
export const getBlobFile = (data, filename) => {
  const blob = new Blob([data])

  if ('download' in document.createElement('a')) {
    const downloadElement = document.createElement('a')
    let href = ''
    if (window.URL) {
      href = window.URL.createObjectURL(blob)
    } else {
      href = window.webkitURL.createObjectURL(blob)
    }
    downloadElement.href = href
    downloadElement.download = filename
    document.body.appendChild(downloadElement)

    // 下载
    downloadElement.click()

    // 释放内存
    if (window.URL) {
      window.URL.revokeObjectURL(href)
    } else {
      window.webkitURL.revokeObjectURL(href)
    }
    document.body.removeChild(downloadElement)
  } else {
    navigator.msSaveBlob(blob, filename)
  }
}

export function isArray(arg) {
  if (typeof Array.isArray === 'undefined') {
    return Object.prototype.toString.call(arg) === '[object Array]'
  }
  return Array.isArray(arg)
}

export function isString(str) {
  if (typeof str === 'string' || str instanceof String) {
    return true
  }
  return false
}

/**
 * @description: 获取url参数
 * @param {*} name
 * @param {*} search
 * @return {*}
 */
export function getQueryString(name, search) {
  search = search || window.location.search.substr(1) || window.location.hash.split('?')[1]
  if (!search) return false
  let reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)')
  let r = search.match(reg)
  if (r != null) return unescape(r[2])
  return null
}

/**
 * @description: 去所有空格
 * @param {*} str
 * @return {*}
 */
export function strTrim(str) {
  return str.replace(/\s+/g, '')
}

export const handleRequest = async function (
  promise,
  successText,
  successCallback,
  errorCallback,
  afterRequest,
  rejected
) {
  let result = null
  try {
    result = await promise
    if (result.data.code * 1 === 200) {
      if (successText) {
        Toast.success(successText)
      }
      const params = result.data.data ? result.data.data : result.data // 后端分页列表接口的数据没有封装在data中
      successCallback && successCallback(params)
    } else {
      const { msg, message } = result.data
      const toastMessage = msg || message || '系统错误'
      Toast.fail({
        message: toastMessage,
        duration: 3000
      })
      errorCallback && errorCallback(result?.data)
    }
  } catch (e) {
    Toast.clear()
    rejected && rejected(e)
  } finally {
    afterRequest && afterRequest(result?.data)
  }
}

/**
 * This is just a simple version of deep copy
 * Has a lot of edge cases bug
 * If you want to use a perfect deep copy, use lodash's _.cloneDeep
 * @param {Object} source
 * @returns {Object}
 */
export function deepClone(source) {
  if (!source && typeof source !== 'object') {
    throw new Error('error arguments', 'deepClone')
  }
  const targetObj = source.constructor === Array ? [] : {}
  Object.keys(source).forEach(keys => {
    if (source[keys] && typeof source[keys] === 'object') {
      targetObj[keys] = deepClone(source[keys])
    } else {
      targetObj[keys] = source[keys]
    }
  })
  return targetObj
}
export function hasPerMission(value) {
  if (value) {
    const permissionFlag = value
    // 有权限
    const hasPermissions = store.state?.user?.menuList?.some(permission => {
      return permission.columnId === permissionFlag
    })
    return hasPermissions
  } else {
    throw new Error(`请设置操作权限标签值`)
  }
}
